import { NotificationI } from "@/interfaces/Notifications";
import "./UserStatus.scss";
import { handleImageError } from "@/utils/GalleryFunctions";
import { getDateFormat2 } from "@/utils/DateFormats";

interface UserStatusPropsI {
  notification: NotificationI;
}

function UserStatus(props: UserStatusPropsI) {
  const { notification } = props;
  return (
    <div className="notification-card-container">
      <div className="title-seen">
        <div>
          <h5>{notification.payload.title}</h5>
        </div>
        <span>
          {notification.isNewElement ? <div className="seen-check"></div> : ""}
        </span>
      </div>
      <h6>{getDateFormat2(notification.createdAt)}</h6>
      <div className="nc-image-container">
        <img src={notification.payload?.photo} onError={handleImageError}></img>
      </div>
    </div>
  );
}

export default UserStatus;
